import { match } from 'ts-pattern'

import { Data } from '@blade/std-lib'

import type { Session as SessionDto } from '../secure-storage-service'

type SessionBase = {
  walletsCount: number
}

export class NotInitialized extends Data.TaggedClass(
  'NotInitialized',
)<SessionBase> {}
export class Locked extends Data.TaggedClass('Locked')<SessionBase> {}
export class Unlocked extends Data.TaggedClass('Unlocked')<SessionBase> {}

export type Session = NotInitialized | Locked | Unlocked

export const fromDto = (dto: SessionDto): Session => {
  return match(dto)
    .returnType<Session>()
    .with(
      { isInitialized: false },
      ({ walletCount }) => new NotInitialized({ walletsCount: walletCount }),
    )
    .with(
      { isLocked: true, isInitialized: true },
      ({ walletCount }) => new Locked({ walletsCount: walletCount }),
    )
    .with(
      { isLocked: false, isInitialized: true },
      ({ walletCount }) => new Unlocked({ walletsCount: walletCount }),
    )
    .exhaustive()
}
